import * as React from 'react';
import { styles } from './styles';
import { PopupProps } from '../../types';

interface Props extends Pick<PopupProps, 'open' | 'disableEscapeKeydown' | 'onClose'> {
  forwardedRef: React.RefObject<HTMLDivElement>;
}

export const PopupWrapper: React.SFC<Props> = ({ forwardedRef, children }) => (
  <div ref={forwardedRef} className={styles.container()}>
    {children}
  </div>
);
